import * as React from "react";
import Container from "@mui/material/Container";
import { Typography } from "@mui/material";

function Accessability() {
  return (
    <Container className="accessibility" maxWidth="xl">
      <div className="accessibility-content">
        <div className="text-section">
          <Typography className="title" variant="h6">
            The O2 Apollo{" "}
          </Typography>
          <Typography className="text">
            The O2 Apollo Manchester is fully accessible. The ground floor has
            an access platform for wheelchair users and customers unable to use
            stairs, the balcony is up approximately 40 steps and has lots of
            seating. Spaces on the access platform are limited and will be
            filled on a first come first served basis. Please
            emailaccess@o2apollomanchester.co.uk for more information.
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            Manchester Academy 1 & 2
          </Typography>
          <Typography className="text">
            These are fully accessible. All the details can be found here.
          </Typography>
          <Typography className="text">
            <a
              href="https://www.manchesteracademy.net/info/accessibility"
              target="_blank"
              rel="noreferrer"
            >
              {"  Manchester Academy 1 & 2 Accessibility"}
            </a>
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            O2 Ritz
          </Typography>
          <Typography className="text">
            The O2 Ritz is partly accessible. The ground floor is fully
            accessible but the balcony and basement are not accessible.
            Customers who are ambulant with access needs can go on the balcony
            where there will be stools reserved (limited numbers). Customers who
            have purchased tickets and require accessible facilities should
            please email access@o2ritzmanchester.co.uk and they will do their
            best to accommodate any needs.
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            Projekts Skatepark
          </Typography>
          <Typography className="text">
            The Skate Park is fully accessible. There is a small viewing
            platform for access. Please let a member of security know on
            entrance to direct you there. We have risen the stage from 2024 but
            please beware, this is a skate park so there’s various levels and
            site lines are a little inconsistent compared to traditional
            venues.{" "}
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            Gorilla
          </Typography>
          <Typography className="text">
            Upon request Gorilla can provide ground floor access to the music
            hall via the bar and restaurant. Upstairs in the venue there have 6
            x seats what can be reserved If you have difficulty standing.
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            Deaf Institute
          </Typography>
          <Typography className="text">
            The music hall where live events take place is situated on the top
            floor and is only accessible by stairs. If customers require
            assistance traveling up and down the stairs or if reserved seating
            would assist those who would find standing difficult, please contact
            the venue info@thedeafinstitute.co.uk and they will be happy to
            help. Please be aware that a lift is not available at this venue.
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            YES
          </Typography>
          <Typography className="text">
            Both YES Basement and YES Pink Room are fully accessible to
            customers using the lift. Each venue will have limited accessibility
            space and will determined on a first come, first serve basis. We
            will try to accommodate as much as we can but we advise to arrive
            early for any particular acts you would like to see. For any further
            information info@manchesterpsychfest.com.
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            The Bread Shed
          </Typography>
          <Typography className="text">
            The Bread Shed is accessible for wheelchairs and have an accessible
            toilet if needed. A ramp can also be provided to customers who would
            like to view events from the raised areas.
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="text">
            Each venue will have limited accessibility space and will determined
            on a first come, first serve basis. We will try to accommodate as
            much as we can but we advise to arrive early for any particular acts
            you would like to see. For any further information
            info@manchesterpsychfest.com.
          </Typography>
        </div>
      </div>
    </Container>
  );
}
export default Accessability;
